import { Link } from "react-router-dom";
import { Users, UserCheck, ArrowUpRight } from "lucide-react";
import Reveal from "@/components/site/Reveal";

export default function CRoles() {
  return (
    <section
      data-testid="c-roles"
      className="py-24 md:py-32 bg-[#3A2E6E] text-white relative overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-[36rem] h-[36rem] rounded-full bg-[#C98FA3]/15 blur-[140px]" />
        <div className="absolute bottom-0 left-0 w-[36rem] h-[36rem] rounded-full bg-[#2847B8]/30 blur-[140px]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-3xl mx-auto">
          <Reveal>
            <span className="text-sm uppercase tracking-[0.2em] text-[#C98FA3] font-medium">
              — Rôles
            </span>
            <h2 className="font-serif-display text-4xl md:text-5xl font-light mt-4 leading-[1.05] text-white">
              Deux façons de participer
            </h2>
            <p className="mt-5 text-base text-white/75">
              Chaque place a sa valeur. Le travail du groupe se nourrit des deux.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-6">
          <Reveal>
            <article
              data-testid="c-role-problematique"
              className="h-full p-10 rounded-3xl bg-white/8 backdrop-blur-md border border-white/15 hover:border-[#C98FA3]/60 transition-colors flex flex-col"
            >
              <div className="w-12 h-12 rounded-full bg-[#C98FA3]/20 flex items-center justify-center">
                <Users className="w-5 h-5 text-[#E6D6DF]" />
              </div>
              <h3 className="font-serif-display text-3xl text-white mt-6">
                Avec votre problématique
              </h3>
              <p className="mt-5 text-base text-white/80 leading-relaxed flex-grow">
                Vous venez avec une situation à explorer. Le travail permet de
                révéler des dynamiques profondes et d'en comprendre les mécanismes.
              </p>
              <Link
                to="/calendrier-ateliers"
                data-testid="c-role-cta-problematique"
                className="mt-8 inline-flex items-center justify-between bg-white text-[#3A2E6E] hover:bg-[#E6D6DF] transition-all duration-300 rounded-full px-6 py-3 font-medium text-sm gap-2 w-fit"
              >
                S'inscrire
                <ArrowUpRight className="w-4 h-4" />
              </Link>
            </article>
          </Reveal>

          <Reveal delay={0.1}>
            <article
              data-testid="c-role-representant"
              className="h-full p-10 rounded-3xl bg-white/8 backdrop-blur-md border border-white/15 hover:border-[#C98FA3]/60 transition-colors flex flex-col"
            >
              <div className="w-12 h-12 rounded-full bg-[#C98FA3]/20 flex items-center justify-center">
                <UserCheck className="w-5 h-5 text-[#E6D6DF]" />
              </div>
              <h3 className="font-serif-display text-3xl text-white mt-6">
                Comme représentant
              </h3>
              <p className="mt-5 text-base text-white/80 leading-relaxed flex-grow">
                Vous participez au travail d'une autre personne. Cette position
                permet souvent des prises de conscience fortes et un travail
                indirect sur vos propres schémas.
              </p>
              <Link
                to="/calendrier-ateliers"
                data-testid="c-role-cta-representant"
                className="mt-8 inline-flex items-center justify-between bg-white text-[#3A2E6E] hover:bg-[#E6D6DF] transition-all duration-300 rounded-full px-6 py-3 font-medium text-sm gap-2 w-fit"
              >
                S'inscrire
                <ArrowUpRight className="w-4 h-4" />
              </Link>
            </article>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
